import { Component, EventEmitter, Input, NgZone, OnDestroy, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material';
import { Subscription } from 'rxjs';
import { IndicadorEnum } from 'src/app/global/enums/indicador.enum';
import { DocumentConfig } from 'src/app/global/interfaces/document-config';
import { DocumentConfigInfo } from 'src/app/global/interfaces/document-config-info';
import { GeneralResponse } from 'src/app/global/interfaces/general-response';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { DatosPersonalesService } from 'src/app/global/services/datos-personales.service';
import { FlujosPaso2PJService } from 'src/app/global/services/flujos-paso-2-pj.service';
import { FlujosPaso2Service } from 'src/app/global/services/flujos-paso-2.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { DocumentVMService } from 'src/app/view-model/services/document-vm.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';

@Component({
  selector: 'app-datos-adjuntos',
  templateUrl: './datos-adjuntos.component.html',
  styleUrls: ['./datos-adjuntos.component.scss']
})
export class DatosAdjuntosComponent implements OnDestroy {
  form: FormGroup = null;
  documentsConfig: DocumentConfig = null;
  documentsCount = null;

  @ViewChild(MatExpansionPanel, { static: false }) matExpansion: MatExpansionPanel;

  subscriptions = new Subscription();

  created = false;

  loading = false;
  loadingDelete = false;

  edicion = true;
  delete = true;

  processing = false;
  private clickTimeout = null;

  @Input() showCantidadCampos = true;

  get flujos() {
    return this.flujosPaso2Serv;
  }

  get flujosPJ() {
    return this.flujosPaso2PJServ;
  }

  @Output() paso5Ok: EventEmitter<any> = new EventEmitter();

  public feriasEventosControlRest = false;
  public boletaFacturaControlRest = false;
  public patenteComercialControlRest = false;
  public fotoCedulaControlRest = false;
  public escrituraControlRest = false;

  constructor(
    private ngZone: NgZone,
    private tagM: TagManagerService,
    private productService: vmProductosService,
    private dialogServ: DialogService,
    private documentVMService: DocumentVMService,
    private flujosPaso2Serv: FlujosPaso2Service,
    private flujosPaso2PJServ: FlujosPaso2PJService,
    private datosPersonalesService: DatosPersonalesService,
    ) { }

  async init() {
    this.form = this.documentVMService.createForm();
    this.form.valueChanges.subscribe((value) => { });
    this.boletaFacturaControl.valueChanges.subscribe(() => { this.documentVMService.documentConfig.BOLETA_O_FACTURA.isLoaded = false; });
    this.fotoCedulaControl.valueChanges.subscribe(() => { this.documentVMService.documentConfig.FOTOGRAFIA_CEDULA.isLoaded = false; });
    this.feriasEventosControl.valueChanges.subscribe(() => { this.documentVMService.documentConfig.FERIAS_Y_EVENTOS.isLoaded = false; });
    this.patenteComercialControl.valueChanges.subscribe(() => { this.documentVMService.documentConfig.PATENTE_COMERCIAL.isLoaded = false; });
    this.escrituraControl.valueChanges.subscribe(() => { this.documentVMService.documentConfig.ESCRITURA.isLoaded = false; });

    this.documentsConfig = this.documentVMService.documentsConfig();
    this.tagM.logEvent(GoogleTagManager.eventPageView().adjDocumentos());

    await this.getDocumentosRequeridos();
  }

  get boletaFacturaControl(): FormControl {
    return this.form.get('BOLETA_O_FACTURA') as FormControl;
  }
  get fotoCedulaControl(): FormControl {
    return this.form.get('FOTOGRAFIA_CEDULA') as FormControl;
  }
  get feriasEventosControl(): FormControl {
    return this.form.get('FERIAS_Y_EVENTOS') as FormControl;
  }
  get patenteComercialControl(): FormControl {
    return this.form.get('PATENTE_COMERCIAL') as FormControl;
  }
  get escrituraControl(): FormControl {
    return this.form.get('ESCRITURA') as FormControl;
  }

  get validForm(): boolean {
    const controls = Object.keys(this.form.controls);
    let valid = true;
    controls.forEach(controlKey => {
      const config = this.documentsConfig[controlKey] as DocumentConfigInfo;
      if (config.show && !config.isLoaded && valid === true) {
        if (this.form.controls[controlKey].invalid) {
          valid = false;
        }
      }
    });
    return valid;
  }

  resetForm() {
    const controls = Object.keys(this.form.controls);
    controls.forEach(controlKey => {
      const config = this.documentsConfig[controlKey] as DocumentConfigInfo;
      if (config.show) {
        this.feriasEventosControlRest = true;
        this.boletaFacturaControlRest = true;
        this.patenteComercialControlRest = true;
        this.fotoCedulaControlRest = true;
        this.escrituraControlRest = true;
        // this.form.controls[controlKey].reset();
        // this.form.controls[controlKey].setValue(value:File, );
      }
    });
    setTimeout(() => {
      this.feriasEventosControlRest = false;
      this.boletaFacturaControlRest = false;
      this.patenteComercialControlRest = false;
      this.fotoCedulaControlRest = false;
      this.escrituraControlRest = false;
    }, 10000);
  }

  async deleteDocuments() {
    const data = {
      title: 'Eliminar documentos',
      description: '¿Deseas eliminar los documentos adjuntados?. <br> <strong>Si seleccionas eliminar documentos, deberás volver a adjuntar los documentos solicitados anteriormente. </strong>',
      cancelButton: 'No, regresar',
      actionButton: 'Sí, eliminar documentos'
    };
    this.dialogServ.openTwoActionsDialog({ data }).afterClosed().subscribe(async (action) => {
      if (action.action === 'OK') {
        this.resetForm();
        this.loadingDelete = true;
        this.delete = false;
        // const resp = await this.documentVMService.deleteDocuments(); ANTES DE KIUWAN
        await this.documentVMService.deleteDocuments();                // DESPUES DE KIUWAN
        this.edicion = await (await this.validaEdicion()).data;
        this.loadingDelete = false;

        this.flujosPaso2Serv.datosAdjuntos.ok = false;
        this.flujosPaso2Serv.cuentaBancaria.mostrar = false;

        this.flujosPaso2PJServ.datosAdjuntos.ok = false;
        this.flujosPaso2PJServ.cuentaBancaria.mostrar = false;
      }
    });
  }

  async getDocumentosRequeridos() {
    try {
      this.edicion = await (await this.validaEdicion()).data;
      const docsReq = await this.documentVMService.getDocumentoRequeridos(this.form) as any[];
      if (docsReq.length === 0) {
        // PN
        this.flujosPaso2Serv.datosAdjuntos.cargando = false;
        this.flujosPaso2Serv.datosAdjuntos.mostrar = false;
        this.flujosPaso2Serv.datosAdjuntos.ok = true;
        this.flujosPaso2Serv.datosAdjuntos.visible = false;
        this.flujosPaso2Serv.cuentaBancaria.cargando = true;

        // PJ
        this.flujosPaso2PJServ.datosAdjuntos.cargando = false;
        this.flujosPaso2PJServ.datosAdjuntos.mostrar = false;
        this.flujosPaso2PJServ.datosAdjuntos.ok = true;
        this.flujosPaso2PJServ.datosAdjuntos.visible = false;
        this.flujosPaso2PJServ.cuentaBancaria.cargando = true;

        this.paso5Ok.emit();
        return;
      }
      this.documentsCount = docsReq.length;
      this.flujosPaso2Serv.datosAdjuntos.bloqueado = false;
      this.flujosPaso2PJServ.datosAdjuntos.bloqueado = false;

      this.documentsConfig = this.documentVMService.documentsConfig();
      if (!this.edicion) {
        this.documentsConfig = this.documentVMService.documentsConfig();
        // PN
        this.flujosPaso2Serv.datosAdjuntos.cargando = false;
        this.flujosPaso2Serv.datosAdjuntos.mostrar = true;
        this.flujosPaso2Serv.datosAdjuntos.ok = true;
        this.flujosPaso2Serv.cuentaBancaria.cargando = true;

        // PJ
        this.flujosPaso2PJServ.datosAdjuntos.cargando = false;
        this.flujosPaso2PJServ.datosAdjuntos.mostrar = true;
        this.flujosPaso2PJServ.datosAdjuntos.ok = true;
        this.flujosPaso2PJServ.cuentaBancaria.cargando = true;

        this.paso5Ok.emit();
        return;
      }
      this.flujosPaso2Serv.datosAdjuntos.cargando = false;
      this.flujosPaso2Serv.datosAdjuntos.mostrar = true;

      this.flujosPaso2PJServ.datosAdjuntos.cargando = false;
      this.flujosPaso2PJServ.datosAdjuntos.mostrar = true;
    } catch (error) {
      this.tagM.logError('Paso 2', error.statusText, error.message);
    }
  }

  validaEdicion(): Promise<GeneralResponse<boolean>> {
    return new Promise((resolve, reject) => {
      const fnSuccess = (edicion: GeneralResponse<boolean>) => {
        resolve(edicion);
      };

      const fnFailure = (error) => {
        console.error(error);
        this.tagM.logError('Paso 2', error.statusText, error.message);
        reject(error);
      };

      this.datosPersonalesService.validaEdicion().subscribe(fnSuccess, fnFailure);
    });
  }

  registraSeleccionProducto() {
    try {
      this.productService.registraSeleccionProductoActual().toPromise();
    } catch (e) {
      console.error('SELECCION PRODUCTO:', e);
    }
  }

  ContinuarGuardar($event: any) {
    $event.stopPropagation(); // Para que no se propague a los componentes inferiores
    if (!(this.processing)) {
      this.tagM.logEvent(GoogleTagManager.eventInteracciones().categoriaAdjuntarDocumentos().accionClick().setEtiqueta("guardar"))
      this.processing = true;
      this.clickTimeout = setTimeout(() => {
        this.submit();
      }, 100);
    }
  }

  async submit(): Promise<void> {
    this.loading = true;
    this.flujosPaso2Serv.datosAdjuntos.ok = false;
    this.flujosPaso2PJServ.datosAdjuntos.ok = false;
    try {
      // const response = await this.documentVMService.saveDocuments(this.form, this.validForm, this.documentsConfig);
      await this.documentVMService.saveDocuments(this.form, this.validForm, this.documentsConfig);
      this.registraSeleccionProducto();
      setTimeout( async () => {
        const status = await this.consultarEstado();
        if (status) {
          this.edicion = await (await this.validaEdicion()).data;
          this.documentsConfig = this.documentVMService.documentsConfig();
          this.loading = false;
          this.processing = false;
          this.flujosPaso2Serv.datosAdjuntos.ok = true;
          this.flujosPaso2PJServ.datosAdjuntos.ok = true;
          this.matExpansion.close();
          if (!this.flujosPaso2Serv.cuentaBancaria.mostrar || !this.flujosPaso2PJServ.cuentaBancaria.mostrar) {
            this.flujosPaso2Serv.cuentaBancaria.cargando = true;
            this.flujosPaso2PJServ.cuentaBancaria.cargando = true;
            this.paso5Ok.emit();
            this.tagM.logDL_adjuntarDocumentos();
          }
        } else {
          this.loading = false;
          this.processing = false;
          const data = {
            title: 'Error al subir documentación',
            description: 'Los archivos no se han cargado en su totalidad, porfavor intente nuevamente',
            actionButton: 'Entendido',
            icon: '../../../assets/icons/icon-informacion.svg'
          };
          this.dialogServ.openOneActionDialog({ data });
        }
      }, 5000);
    } catch (e) {
      this.loading = false;
      this.processing = false;
      this.tagM.logError('Paso 2', e.statusText, e.message);
      console.error('error -> ' + e);
      if (e.error.indicador === IndicadorEnum.DOCUMENTO_CORRUPTO) {
        const docs = Object.keys(this.documentsConfig);
        docs.forEach((doc) => {
          if (e.error.mensaje.contenido.includes(doc)) {
            this.documentsConfig[doc].corrupted = true;
          } else {
            this.documentsConfig[doc].corrupted = false;
          }
        });
        return;
      }
    }
  }

  async consultarEstado(): Promise<boolean> {
    const status = await this.documentVMService.getDocumentStatus() as any[];
    const docs = status.length;
    let contDocs = 0;
    status.forEach((doc) => {
      if (doc.estado === 'GUARDADO') {
        contDocs++;
      }
    });
    if (docs === contDocs) {
      return true;
    } else {
      return false;
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.documentVMService.stopDocumentStatusRequester();
  }


}
